import { CircularProgress, styled } from '@material-ui/core'

export const Progress = styled(CircularProgress)(({ theme }) => ({
  color: theme.colors.brand
}))

export const WhiteProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.colors.white
}))
